
/** Start page widgets */
export enum WidgetType {
  calendar = 'calendar',
  email = 'email',
  visitationIndex = 'visitationIndex',
  files = 'files',
  livligSpotlight = 'livlig',
  livligSellThePlan = 'selltheplan',
  social = 'social',
  tasks = 'tasks',
  translation = 'translation',
  contacts = 'contacts',
  sales = 'sales',
  sharePointFiles = 'sharePointFiles',
  fixa = 'fixa',
}

/** List with all widgets */
export const ALL_WIDGETS: WidgetType[] = Object.keys(WidgetType).map(key => WidgetType[key]);
